<template>
  <div class="hero-banner critical-component-clear">
    <div class="hero-banner__content-wrapper">
      <div
        class="hero-banner__overlay"
        :class="settings.overlay"
      />

      <art-direction
        v-if="!settings.mobileVideo && !settings.desktopVideo"
        :image-desktop="settings.desktopImage"
        :image="settings.mobileImage"
        :alt="settings.desktopImage.alt"
        ratio="5:7"
        ratio-desktop="2:1"
      />

      <template v-else>
        <video-player
          v-if="settings.desktopVideo"
          class="hero-banner__video desktop"
          :sources="settings.desktopVideo.sources"
          :image="settings.desktopVideo.previewImage"
          :intersection-observer="{
            enable: true,
          }"
          :controls="{
            playPause: false,
          }"
          ratio="2:1"
          sizes="100vw"
        />

        <video-player
          v-if="settings.mobileVideo"
          class="hero-banner__video mobile"
          :sources="settings.mobileVideo.sources"
          :image="settings.mobileVideo.previewImage"
          :intersection-observer="{
            enable: true,
          }"
          :controls="{
            playPause: false,
          }"
          ratio="5:7"
          sizes="100vw"
        />
      </template>
    </div>

    <div
      class="hero-banner__grid grid container"
      :class="[settings.horizontalAlign, settings.verticalAlign]"
    >
      <div
        class="hero-banner__text-wrapper col xs-span"
        :class="settings.wrapperColumn"
      >
        <p
          v-if="settings.subtitle"
          class="hero-banner__subtitle text-heading-m"
          v-text="settings.subtitle"
        />

        <p
          v-if="settings.title"
          class="hero-banner__title text-heading-4xl text-heading-5xl-desktop"
          v-text="settings.title"
        />

        <p
          v-if="settings.bodyText"
          class="hero-banner__description text-body-m-regular"
          v-text="settings.bodyText"
        />

        <btn
          v-if="settings.ctaText && settings.ctaLink"
          :label="settings.ctaText"
          class="hero-banner__button"
          modifiers="text dark"
          :url="settings.ctaLink"
        />

        <div
          v-if="settings.product"
          class="hero-banner__product"
        >
          <product-prices
            :available="variant?.available"
            :compare-at-price="variant?.compareAtPrice?.amount"
            :loading="!variant"
            :price="variant?.price?.amount"
            :varies="variant?.price?.varies"
            :price-first="false"
          />

          <div
            class="hero-banner__product-form"
          >
            <mini-product-form
              class="hero-banner__product-form"
              :product="settings.product"
              :section-id="liquid.sectionId"
              :settings="{
                displayQuantitySelector: false,
                excludedInitialSelectOptions: ['length', 'waist', 'width'],
                selectDisabledValues: false,
                ctaModifiers: 'text dark',
                ctaShowIcon: true,
                hideUnavailableValues: true
              }"
              :variant="variant"
              @update-variant="handleVariantUpdate"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Hero banner new (hero-banner)
 * -----------------------------------------------------------------------------
 * Hero banner with image/video and product options.
 * - Component settings: section / dynamic / async / scroll
 *
 * @param {Object} settings - Section's settings.
 *
 */

import ArtDirection from '~global/images/art-direction'
import VideoPlayer from '~global/video-player/video-player'
import Btn from '~global/btn/btn'
import ProductPrices from '~global/product-prices/product-prices'
import MiniProductForm from '~async/mini-product-form/mini-product-form'

import { emitUpdateRequestObject } from '~/helpers/vue'

export default {
  name: 'HeroBanner',

  components: {
    ArtDirection,
    VideoPlayer,
    Btn,
    ProductPrices,
    MiniProductForm,
  },

  props: {
    liquid: {
      type: Object,
      default: () => ({
        sectionId: '',
      }),
    },
    settings: {
      type: Object,
      default: () => ({}),
    },
  },

  emits: {
    'update-request-object': emitUpdateRequestObject,
  },

  data() {
    return {
      variant: false,
    }
  },

  mounted() {
    this.variant = this.settings?.product?.selectedOrFirstAvailableVariant
  },

  methods: {

    /**
     * Handle variant update from product form.
     * @param {Boolean|Null|Object} variant - Emitted variant.
     */
    handleVariantUpdate(variant) {
      this.variant = variant
    },
  },
}
</script>

<style lang="scss">
@import './hero-banner';
</style>
